var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        key: _vm.stateKey,
        attrs: {
          hover: "",
          small: "",
          "caption-top": "",
          responsive: "sm",
          items: _vm.items,
          fields: _vm.columns
        },
        scopedSlots: _vm._u([
          {
            key: "cell(guests)",
            fn: function(ref) {
              var ref_item = ref.item
              var guests = ref_item.guests
              var justifications = ref_item.justifications
              var item = ref.item
              return [
                _c(
                  "div",
                  {
                    staticClass: "flex flex-row gap-2 __guest-statistics",
                    on: {
                      click: function($event) {
                        return _vm.$emit("clicked-guest-statistics", item)
                      }
                    }
                  },
                  [
                    _vm._.isArray(guests)
                      ? _c(
                          "b",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  delay: { show: 10, hide: 10 },
                                  content: _vm.$tc(
                                    "guests_confirmed",
                                    guests.length,
                                    [guests.length]
                                  )
                                },
                                expression:
                                  "{\n              delay: {show: 10, hide: 10},\n              content: $tc('guests_confirmed', guests.length, [guests.length])\n            }"
                              }
                            ],
                            staticClass: "text-success"
                          },
                          [_vm._v(" " + _vm._s(guests.length) + " ")]
                        )
                      : _vm._e(),
                    _vm._.isArray(justifications) && justifications.length > 0
                      ? _c(
                          "b",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  delay: { show: 10, hide: 10 },
                                  content: _vm.$tc(
                                    "guests_rejected",
                                    justifications.length,
                                    [justifications.length]
                                  )
                                },
                                expression:
                                  "{\n              delay: {show: 10, hide: 10},\n              content: $tc('guests_rejected', justifications.length, [justifications.length])\n            }"
                              }
                            ],
                            staticClass: "text-danger"
                          },
                          [_vm._v(" " + _vm._s(justifications.length) + " ")]
                        )
                      : _vm._e()
                  ]
                )
              ]
            }
          },
          {
            key: "cell(action)",
            fn: function(ref) {
              var item = ref.item
              var index = ref.index
              return [
                _vm.canRemove
                  ? _c("feather-icon", {
                      staticClass:
                        "h-5 w-5 mr-3 stroke-current text-danger cursor-pointer",
                      attrs: { icon: "XCircleIcon", size: "21" },
                      on: {
                        click: function($event) {
                          return _vm.actionEvent("clicked-remove", item)
                        }
                      }
                    })
                  : _vm._e(),
                _vm.withinDate(item.start_at, item.finish_at)
                  ? [
                      !_vm.isScheduled(item) &&
                      _vm.canParticipate &&
                      item.id &&
                      !_vm.anyConfirmed
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(40, 199, 111, 0.15)",
                                  expression: "'rgba(40, 199, 111, 0.15)'",
                                  modifiers: { "400": true }
                                }
                              ],
                              attrs: { variant: "flat-success" },
                              on: {
                                click: function($event) {
                                  return _vm.actionEvent(
                                    "clicked-confirm",
                                    item,
                                    index
                                  )
                                }
                              }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "CheckIcon" }
                              }),
                              _c("span", { staticClass: "align-middle" }, [
                                _vm._v("Confirmar")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isScheduled(item)
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(40, 199, 111, 0.15)",
                                  expression: "'rgba(40, 199, 111, 0.15)'",
                                  modifiers: { "400": true }
                                }
                              ],
                              attrs: { variant: "flat-warning" },
                              on: {
                                click: function($event) {
                                  return _vm.actionEvent(
                                    "clicked-disconfirm",
                                    item,
                                    index
                                  )
                                }
                              }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "XCircleIcon" }
                              }),
                              _c("span", { staticClass: "align-middle" }, [
                                _vm._v("Desmarcar")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm._t("after")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }